// var target = $j('[data-section-type="collection-grid"]').get(0);
// console.log('target',target)
// create an observer instance

var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    // do stuff when
    // `childList`, `subtree` of `#myTable` modified
    // console.log('mutation.target',mutation.target)
    // console.log('mutation',mutation.target.classList.contains("grid-product"))

    if (mutation.target.classList.contains("grid-product")){
      // console.log("mutation",mutation.target.childNodes, typeof(mutation.target))
      for(var child of mutation.target.childNodes){
        if (child.classList){
          if (child.classList.contains('grid-product__content')){
            // console.log('grid-product__content')
            for(var c of child.childNodes){
              if (c.classList){
                if (c.classList.contains('grid__item-image-wrapper')){
                  // console.log('c',c.classList)
                  var product_id= c.getAttribute('js-product-id')
                  if ($j(`.custom-selector-wrapper--${product_id} div`).hasClass('loader-selector')){
                    // console.log('call getProductColorSwatch')
                    var product_type= c.getAttribute('js-product-type')
                    var current_p_colour= c.getAttribute('js-product-colour')
                    // var product_id= c.getAttribute('js-product-id')
                    var product_handle = c.getAttribute('js-product-handle')
                    $j(`.custom-selector-wrapper--${product_id} div`).removeClass('loader-selector');
                    getProductColorSwatch(product_type,current_p_colour,product_id )

                    var nexturl = $j('.collection-grid__wrapper .grid--uniform').attr('data-next-url')
                    const searchParams = new URLSearchParams(nexturl);
                    // console.log('nexturl swatch',nexturl)
                    // console.log(parseInt(searchParams.get('page')))
                    var initbutton = true
  
                    if (window.location.pathname.indexOf('/collections/') !== -1 && window.location.pathname.indexOf('/products/') === -1 ){
                      // console.log($j('.collection-grid__wrapper .grid--uniform .grid-product').length)
  
                      if ($j('.collection-grid__wrapper .grid--uniform .grid-product').length <= 36 ){
                        initbutton = false
                      }
                    }
                    else{
                    
                    }
                    
                    if ( initbutton ){
                      const wishlist_button = document.querySelector('[button-wishlist][data-product-handle="'+product_handle+'"]')
                      // console.log('wishlistbutton',wishlist_button)
                      const productHandle = wishlist_button.dataset.productHandle || false;
                      const productType = wishlist_button.dataset.productType || false;
                      if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
                      if (wishlistContains(productHandle+'_'+productType)){
                        wishlist_button.classList.add(BUTTON_ACTIVE_CLASS);
                        wishlist_button.querySelector('.icon-heart').classList.add('fa-solid')
                        wishlist_button.querySelector('.icon-heart').classList.remove('fa-regular')
                        // wishlist_button.classList.add(BUTTON_ACTIVE_CLASS);
                        // to display add wishlist / remove wishlist
                        // try{
                        //   let button_text = wishlist_button.querySelector('.btn__inner').querySelector('.btn__text')
                        //   button_text.innerText = "Remove Wishlist"
                        // }
                        // catch(err) {
                        // }
                  
                      } 
                      wishlist_button.addEventListener('click', () => {
                        const productHandle = wishlist_button.dataset.productHandle || false;
                        const productType = wishlist_button.dataset.productType || false;
                        updateWishlist(productHandle, wishlist_button);
                        // console.log(productHandle)
                        wishlist_button.classList.toggle(BUTTON_ACTIVE_CLASS);
                        wishlist_button.querySelector('.icon-heart').classList.toggle('fa-solid')
                        wishlist_button.querySelector('.icon-heart').classList.toggle('fa-regular')
                        jQuery.getJSON('/products/'+productHandle+'.js', function(product) {
                          // console.log("product",product.featured_image);
                          img_html = '<img src="'+product.featured_image+'" width="60px;">'
                          document.querySelector('.wishlist-modal .wishlist-image').innerHTML = img_html;
                          document.querySelector('.wishlist-modal').style.display = "block";
                          setTimeout(function() {document.querySelector('.wishlist-modal').style.display = "none"}, 3000);
                        })
                      
                    });
                    }
                      
                      // console.log('product_handle',product_handle)
                      // console.log('product_id',product_id)
                      // console.log('current_p_colour',current_p_colour)
                      // console.log('product_type',product_type)
                    }
                    
                  }
              }
              
            }
          }
        }
      }
    }
  });    
});


// configuration of the observer:
var config = { childList: true, subtree:true, attributes: true, attributeOldValue: true, attributeFilter: ['class'] };

// pass in the target node, as well as the observer options
// observer.observe(target, config);
$j('[data-section-type="collection-grid"]').each(function( index ) {
  var target = $j('[data-section-type="collection-grid"]').get(index);
  // console.log('target',target)
  observer.observe(target, config);
  
});

// $("#myTable tbody").append("<tr><td>abc</td></tr><tr><td>def</td></tr>")
  
